import React from 'react';
import {Outlet, useNavigate, useLocation, useParams} from 'react-router-dom';
import {Box, Tab, Tabs, Toolbar, Typography } from '@mui/material';


// Übersicht über die verschiedenen TABs, also die vorhandenen
// Menüfunktionen
const TABS = [
  { label : 'Turnierverwaltung', path: 'tournament' },
  { label : 'Parameter', path: 'parameters' },
  { label : 'Finanzen', path: 'financials' },
  { label : 'Essensbuchungen', path: 'meals'},
  { label : 'Kontakte', path: 'contacts' },
  { label : 'Posteingang', path: 'email' },
  { label : 'Versionsinfo', path: 'about' },
];


export default function Admin()
{

  const {year} = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // wir schalten erstmal das erste Tab direkt als Aktiv ein, 
  // oder jenes, welches zu unserem Pfad passt.
  const activeTab = Math.max(0, TABS.findIndex(tab => location.pathname.includes(tab.path)));

  return (
    <Box>
      <Toolbar>
        <Typography variant="h5">Administration {year}</Typography>        
      </Toolbar>
      <Tabs value={activeTab} onChange={(event,i) => navigate(`/${year}/admin/${TABS[i].path}`)}>                
        {TABS.map(tab => <Tab key={tab.path} label={tab.label} />)}
      </Tabs>
      <Box sx={{p:2}}>
        <Outlet />
      </Box>
    </Box>
  );

}


